<template>
    <b-card>
        <load-spinner :loading="isLoading" />
        <p>Current Group: {{ student.cgroup }}</p>
        <FullCalendar
            :options="calendarOptions"
        />
    </b-card>
</template>

<script>

import FullCalendar from '@fullcalendar/vue';
import dayGridPlugin from '@fullcalendar/daygrid';

export default {
    components: {
        FullCalendar
    },
    props: {
        student: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            isLoading: false,
            calendarOptions: {
                locale: 'en-au',
                plugins: [dayGridPlugin],
                defaultView: "dayGridMonth",
                events: this.fetchEvents,
                height: 600
            }
        };
    },
    computed: {
    },
    watch: {
    },
    mounted() {
    },
    methods: {
        fetchEvents(info, successCallback, failureCallback) {
            this.isLoading = true;
            axios
                .get('/api/group_dates', {
                    params: {
                        departmentId: this.student.department_id,
                        currentGroup: this.student.cgroup,
                        startDate: moment(info.start).format('YYYY-MM-DD'),
                        endDate: moment(info.end).add(-1, 'day').format('YYYY-MM-DD')
                    }
                })
                .then((response) => {
                    let events = response.data.data.map((event) => {
                        return {
                            start: moment(event.GroupDate).toDate(),
                            end: moment(event.GroupDate).toDate(),
                            allDay: true,
                            title: event.CurrentGroup
                        }
                    });
                    successCallback(events);
                    this.isLoading = false;
                });
        }
    },
};

</script>
